module.exports = __webpack_public_path__ + "static/media/alterIcon.f578e68a.svg";